import { faker } from "@faker-js/faker";

import { merge } from "@/__mocks__/mockHelpers";
import { fakePatientObservationData } from "@/__mocks__/vitals/observation";

const fakeWeightData = (
  overrides?: DeepPartial<PatientObservationData>,
): PatientObservationData => {
  const weightData: PatientObservationData = fakePatientObservationData({
    observation: {
      unit: "lbs",
      value: faker.number.float({ fractionDigits: 4, max: 200, min: 100 }),
    },
  });
  return merge(weightData, overrides);
};

export { fakeWeightData };
